<template>
    <button
        class="size-[32px] shrink-0 border border-brand-2-950/10 hover:select-filter-active flex items-center justify-center rounded-full lh-transition text-brand-2-950"
    >
        <span
            class="w-[12px]"
            v-html="DeleteIcon"
        ></span>
    </button>
</template>

<script setup>
    import DeleteIcon from '@img/icons/delete.svg?raw';
</script>
